import { useQuery } from '@apollo/client';

import {
  edgesFromData,
  pageInfoFromData,
  mergeNewPage,
} from 'helpers/graphql-utils';

import GET_PROJECT_USERS from '../graphql/GetProjectUsers.graphql';
import { ORDER_BY_NAME } from '../constants';

const PATH = 'viewer.project.projectUsers';

const useProjectUsers = ({ projectId, first = 100, after = null }) => {
  const {
    data,
    previousData,
    loading,
    error,
    fetchMore,
    refetch,
    networkStatus,
  } = useQuery(GET_PROJECT_USERS, {
    variables: { projectId, first, after, orderBy: ORDER_BY_NAME },
    notifyOnNetworkStatusChange: true,
  });

  const recentData = data ?? previousData;
  const isLoading = loading && !recentData;

  const pageInfo = pageInfoFromData(recentData, PATH);
  const projectUsers = edgesFromData(recentData, PATH).map((edge) => edge.node);
  const projectUsersCount = recentData?.viewer.project.projectUserCount ?? 0;

  const fetchNextPage = async () => {
    fetchMore({
      variables: { projectId, first, after: pageInfo.endCursor },
      updateQuery: (oldData, newData) => mergeNewPage(oldData, newData, PATH),
    });
  };

  return {
    projectUsers,
    projectUsersCount,
    loading: isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: pageInfo.hasNextPage,
    networkStatus,
  };
};

export default useProjectUsers;
